<common-activity-type-base [activity]="activity" [showStatus]="showStatus" [pendingReviewBanner]="pendingReviewBanner">
  <ng-container *ngIf="activity.storageModel == null">
    <common-drag-drop-file-upload (fileChange)="onFileSelected($event)"></common-drag-drop-file-upload>
  </ng-container>
  <ng-container *ngIf="activity.storageModel != null">
    <div class="px-0">
      <div class="d-lg-flex justify-content-between mb-3 mb-lg-0">
        <label>File</label>
        <div>
          <a [attr.href]="blobUrl" target="_blank" class="font-weight-light">{{ fileName }}</a>
        </div>
      </div>
      <div class="d-lg-flex justify-content-between mb-3 mb-lg-0">
        <label>Date Uploaded</label>
        <div class="font-weight-light">{{ activity.storageModel.createdDateTime | date: "medium" }}</div>
      </div>
    </div>
    <button
      class="btn btn-block btn-mobile btn-outline-secondary mt-4"
      *ngIf="activity.status == 'PendingReview' || activity.status == 'Denied' || (fileName != null && activity.status == 'Open')"
      (click)="delete()"
    >
      <i class="icon-delete fs-20"></i> Delete {{ fileName || "File" }}
    </button>
  </ng-container>
</common-activity-type-base>
